module.exports = __webpack_public_path__ + "static/media/client.22a660d6.png";